import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["icon", "message"];
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewSenderPopoverButton = _ref => {
  let {
      icon,
      message
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    href,
    onClick,
    target
  } = rest;
  return /*#__PURE__*/_jsxs(Button, {
    size: "small",
    use: "secondary-ghost",
    href: href,
    onClick: onClick,
    target: target,
    children: [/*#__PURE__*/_jsx(View, {
      marginInlineEnd: "200",
      as: "span",
      children: icon
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: message
    })]
  });
};
ViewSenderPopoverButton.propTypes = {
  icon: PropTypes.node,
  href: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
};
export default ViewSenderPopoverButton;